import { Injectable } from '@angular/core';
import { AuthenticationService, User } from './authentication.service';

@Injectable({
  providedIn: 'root'
})
export class UserPermissionsService {

  public get Permissioins(): UserPermissions | undefined {
    return this.authenticationService.userValue?.Permissions;
  }

  public get ContractsTab(): ContractsTab {
    if (this.authenticationService.userValue) {
      return this.authenticationService.userValue.Permissions.ContractsTab;
    }
    return {
      ExpensesTab: { Visible: false },
      OrdersTab: { Visible: false },
      AttachmentsTab: { Visible: false },
      SchedulingTab: { Visible: false },
      JobName: { Visible: false },
      Reference: { Visible: false },
      ContractID: { Visible: false },
      Total: { Visible: false },
      Paid: { Visible: false },
      Remaining: { Visible: false },
      Rep: { Visible: false },
      EstLabor: { Visible: false },
      ActLabor: { Visible: false },
      Hours: { Visible: false },
      Est3rdParty: { Visible: false },
      Act3rdParty: { Visible: false },
      EstProfit: { Visible: false },
      ActProfit: { Visible: false },
      EstMargin: { Visible: false },
      ActMargin: { Visible: false },
      Month: { Visible: false },
      Year: { Visible: false },
      IsClosed: { Visible: false },
      DocId: { Visible: false },
      BilledAmount: { Visible: false },
      Orders: { Visible: false },
      JobNum: { Visible: false },
      Size: { Visible: false },
      Notes: { Visible: false },
      Status: { Visible: false },
      PermitStatus: { Visible: false },
      WorkDays: { Visible: false },
      ScheduleDate: { Visible: false },
      ContractDate: { Visible: false },
      ScheduleNotes: { Visible: false },
      Crew: { Visible: false },
      City: { Visible: false },
      AttachmentCount: { Visible: false },
      SpruceNotes: { Visible: false },
      EstLaborMargin: { Visible: false },
      ActLaborMargin: { Visible: false },      
      SpruceHours: { Visible: false },
    };
  }


  public get CanViewContractsTab(): boolean {
    return this.authenticationService.userValue?.Permissions.Contracts.Visible ?? false;
  }
  public get CanViewProposalsTab(): boolean {
    return this.authenticationService.userValue?.Permissions.Proposals.Visible ?? false;
  }
  public get CanViewSchedulerTab(): boolean {
    return this.authenticationService.userValue?.Permissions.Scheduler.Visible ?? false;
  }
  public get CanViewSettingsTab(): boolean {
    return this.authenticationService.userValue?.Permissions.Settings.Visible ?? false;
  }



  public get CanViewExpensesTab(): boolean {
    return this.authenticationService.userValue?.Permissions.ContractsTab.ExpensesTab.Visible ?? false;
  }
  public get CanViewOrdersTab(): boolean {
    return this.authenticationService.userValue?.Permissions.ContractsTab.OrdersTab.Visible ?? false;
  }
  public get CanViewAttachmentsTab(): boolean {
    return this.authenticationService.userValue?.Permissions.ContractsTab.AttachmentsTab.Visible ?? false;
  }
  public get CanSchedulingTab(): boolean {
    return this.authenticationService.userValue?.Permissions.ContractsTab.SchedulingTab.Visible ?? false;
  }

  constructor(private authenticationService: AuthenticationService) {

  }

}




export interface UserPermissions {
  Scheduler: UITab;
  Proposals: UITab;
  Settings: UITab;
  Contracts: UITab;
  ContractsTab: ContractsTab;
}

export interface ContractsTab {
  ExpensesTab: UITab;
  OrdersTab: UITab;
  AttachmentsTab: UITab;
  SchedulingTab: UITab;
  JobName: Column;
  Reference: Column;
  ContractID: Column;
  Total: Column;
  Paid: Column;
  Remaining: Column;
  Rep: Column;
  EstLabor: Column;
  ActLabor: Column;
  Hours: Column;
  Est3rdParty: Column;
  Act3rdParty: Column;
  EstProfit: Column;
  ActProfit: Column;
  EstMargin: Column;
  ActMargin: Column;
  Month: Column;
  Year: Column;
  IsClosed: Column;
  DocId: Column;
  BilledAmount: Column;
  Orders: Column;
  JobNum: Column;
  Size: Column;
  Notes: Column;
  Status: Column;
  PermitStatus: Column;
  WorkDays: Column;
  ScheduleDate: Column;
  ContractDate: Column;
  ScheduleNotes: Column;
  Crew: Column;
  City: Column;
  AttachmentCount: Column;
  SpruceNotes: Column;

  EstLaborMargin: Column;
  ActLaborMargin: Column;
  SpruceHours: Column;
}

export interface Column {
  Visible: boolean;
}

export interface UITab {
  Visible: boolean;
}
